/**
 * Shared animation utilities
 */

/**
 * Easing function for smooth animation
 */
export const easeInOutCubic = (t: number): number => {
    return t < 0.5 ? 4 * t * t * t : 1 - (-2 * t + 2) ** 3 / 2;
};
